import { render, staticRenderFns } from "./BaseManagementItem.vue?vue&type=template&id=68b56ff1&scoped=true&"
import script from "./BaseManagementItem.vue?vue&type=script&lang=js&"
export * from "./BaseManagementItem.vue?vue&type=script&lang=js&"
import style0 from "./BaseManagementItem.vue?vue&type=style&index=0&id=68b56ff1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b56ff1",
  null
  
)

export default component.exports